import { render, staticRenderFns } from "./card-satellite-rivoneed.vue?vue&type=template&id=417485ec&scoped=true&"
import script from "./card-satellite-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-satellite-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-satellite-rivoneed.vue?vue&type=style&index=0&id=417485ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417485ec",
  null
  
)

export default component.exports